function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { CoreVideoInternal } from '../core-video-internal';
import { sdkLogger } from '../logger';
import { allSettled } from '../utils/promise-utils';
export var AddonManager = /*#__PURE__*/ function() {
    "use strict";
    function AddonManager(addonsConfig, sessionItem, videoPlatformIntegration, session, addonsFactories) {
        _class_call_check(this, AddonManager);
        _define_property(this, "addonsConfig", void 0);
        _define_property(this, "sessionItem", void 0);
        _define_property(this, "videoPlatformIntegration", void 0);
        _define_property(this, "session", void 0);
        _define_property(this, "addonsFactories", void 0);
        _define_property(this, "eventBoundaryAddon", void 0);
        _define_property(this, "heartbeatAddon", void 0);
        _define_property(this, "watermarkingAddon", void 0);
        _define_property(this, "streamMetadataFiltererAddon", void 0);
        _define_property(this, "streamMetadataParserAddon", void 0);
        _define_property(this, "linearContentEmbargoAddon", void 0);
        _define_property(this, "syntheticEventAddons", void 0);
        _define_property(this, "isAdvertisingPrepared", void 0);
        _define_property(this, "currentVideoElement", void 0);
        this.addonsConfig = addonsConfig;
        this.sessionItem = sessionItem;
        this.videoPlatformIntegration = videoPlatformIntegration;
        this.session = session;
        this.addonsFactories = addonsFactories;
        this.isAdvertisingPrepared = false;
        this.session.onVideoElementCreated(this.handleVideoElementCreated.bind(this));
    }
    _create_class(AddonManager, [
        {
            key: "load",
            value: function load(playerCapabilities) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        _this.eventBoundaryAddon = _this.instantiateAddon(_this.addonsFactories.eventBoundary, [
                            _this.addonsConfig.eventBoundary,
                            _this.session
                        ]);
                        _this.heartbeatAddon = _this.instantiateAddon(_this.addonsFactories.heartbeat, [
                            _this.addonsConfig.heartbeat,
                            _this.videoPlatformIntegration,
                            _this.session,
                            _this.sessionItem
                        ]);
                        _this.streamMetadataFiltererAddon = _this.instantiateAddon(_this.addonsFactories.streamMetadataFilterer, [
                            _this.session,
                            _this.sessionItem
                        ]);
                        _this.streamMetadataParserAddon = _this.instantiateAddon(_this.addonsFactories.streamMetadataParser, [
                            _this.session,
                            _this.sessionItem
                        ]);
                        _this.syntheticEventAddons = _this.instantiateAddon(_this.addonsFactories.syntheticEvents, [
                            _this.session,
                            _this.sessionItem,
                            playerCapabilities
                        ]) || [];
                        _this.linearContentEmbargoAddon = _this.instantiateAddon(_this.addonsFactories.linearContentEmbargo, [
                            _this.session
                        ]);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "lazyLoad",
            value: // Load and initialize addons lazily as PlayoutData demands
            function lazyLoad(playerCapabilities, playoutData) {
                var _this = this;
                return _async_to_generator(function() {
                    var addonLoaders, // Upon load, the addon may have missed on the initial playback observable notifications
                    _this_watermarkingAddon, _CoreVideoInternal_getPropositionExtensions_watermarkingPolicy;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                sdkLogger.verbose('Lazy loading addons');
                                addonLoaders = CoreVideoInternal.getPropositionExtensions().addonLoaders;
                                // We want failed addons to fail without blocking other addons from loading
                                return [
                                    4,
                                    allSettled(addonLoaders.filter(function(loader) {
                                        return loader.isLazy && loader.shouldLoadForPlayout(playoutData);
                                    }).map(function(loader) {
                                        return loader.load(CoreVideoInternal.config);
                                    }))
                                ];
                            case 1:
                                _state.sent();
                                if (_this.addonsFactories.watermarking && playoutData.watermarking) {
                                    ;
                                    ;
                                    _this.watermarkingAddon = _this.instantiateAddon(_this.addonsFactories.watermarking, [
                                        _this.addonsConfig.watermarking,
                                        _this.session,
                                        (_CoreVideoInternal_getPropositionExtensions_watermarkingPolicy = CoreVideoInternal.getPropositionExtensions().watermarkingPolicy) !== null && _CoreVideoInternal_getPropositionExtensions_watermarkingPolicy !== void 0 ? _CoreVideoInternal_getPropositionExtensions_watermarkingPolicy : null
                                    ]);
                                    (_this_watermarkingAddon = _this.watermarkingAddon) === null || _this_watermarkingAddon === void 0 ? void 0 : _this_watermarkingAddon.lazyInit(_this.currentVideoElement, playoutData, _this.session.getCurrentState());
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getReportingAddons",
            value: function getReportingAddons() {
                return this.session.getPrecursor().getReportingAddons();
            }
        },
        {
            key: "prepareAdvertising",
            value: function prepareAdvertising(advertisingData) {
                if (!this.isAdvertisingPrepared) {
                    this.getReportingAddons().forEach(function(a) {
                        return a.setupAdvertising(advertisingData);
                    });
                    this.isAdvertisingPrepared = true;
                }
            }
        },
        {
            key: "filterAudioTracks",
            value: function filterAudioTracks(audioTracks) {
                if (this.streamMetadataFiltererAddon) {
                    return this.streamMetadataFiltererAddon.filterAudioTracks(audioTracks);
                }
                return audioTracks;
            }
        },
        {
            key: "filterSubtitlesTracks",
            value: function filterSubtitlesTracks(subtitlesTracks) {
                if (this.streamMetadataFiltererAddon) {
                    return this.streamMetadataFiltererAddon.filterSubtitlesTracks(subtitlesTracks);
                }
                return subtitlesTracks;
            }
        },
        {
            key: "isWatermarkingEnabled",
            value: function isWatermarkingEnabled() {
                return Boolean(this.watermarkingAddon);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this = this;
                var wrappedPromises = [
                    this.eventBoundaryAddon,
                    this.heartbeatAddon,
                    this.watermarkingAddon,
                    this.streamMetadataParserAddon,
                    this.linearContentEmbargoAddon
                ].concat(_to_consumable_array(this.syntheticEventAddons || [])).filter(function(addon) {
                    return !!addon;
                }).map(/*#__PURE__*/ function() {
                    var _ref = _async_to_generator(function(addon) {
                        var e, message;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        2,
                                        ,
                                        3
                                    ]);
                                    return [
                                        4,
                                        addon === null || addon === void 0 ? void 0 : addon.destroy()
                                    ];
                                case 1:
                                    _state.sent();
                                    sdkLogger.verbose("Addon destroyed: ".concat(addon === null || addon === void 0 ? void 0 : addon.name));
                                    return [
                                        2
                                    ];
                                case 2:
                                    e = _state.sent();
                                    message = "Error while destroying addon [".concat(addon === null || addon === void 0 ? void 0 : addon.name, "]: ").concat(e);
                                    sdkLogger.warn(message);
                                    _this.session.notifyWarning('ADDON_MANAGER.DESTROY', message);
                                    throw e;
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(addon) {
                        return _ref.apply(this, arguments);
                    };
                }());
                return allSettled(wrappedPromises);
            }
        },
        {
            key: "instantiateAddon",
            value: function instantiateAddon(factory, args) {
                if (!factory) {
                    return undefined;
                }
                try {
                    return factory.apply(void 0, _to_consumable_array(args));
                } catch (error) {
                    var msg = "Error while loading addons: ".concat(error);
                    sdkLogger.error(msg, error);
                    this.session.notifyWarning('ADDON_MANAGER.LOAD', msg);
                }
            }
        },
        {
            key: "handleVideoElementCreated",
            value: function handleVideoElementCreated(videoElement) {
                this.currentVideoElement = videoElement;
            }
        }
    ]);
    return AddonManager;
}();

//# sourceMappingURL=addon-manager.js.map